import TreeView from "@mui/lab/TreeView";
import { IThemeProps } from 'component/theme';
import styled from 'styled-components';
import { FormControlLabel } from '@mui/material';
import { alpha } from "@mui/material/styles";

export const StyledTreeView = styled(TreeView)`
  ${({ theme }) => `
    padding-left: ${theme.uptimeSpace[10]}px !important;
    .MuiCheckbox-colorPrimary {
      color: ${theme.uptimeColors.grayScales.darkerGray};
    }
    .MuiTreeItem-label {
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
      background-color: transparent !important;
    }
    .MuiTreeItem-group {
      margin-left: ${theme.uptimeSpace[8]}px !important;
      border-left: 1px dashed ${alpha(theme.uptimeColors.grayScales.black, 0.4)};
    }
    .Mui-checked {
      color: ${theme.uptimeColors.mainTheme.primary} !important;
    }
    .parent-treee-item {
      margin-left: ${theme.uptimeSpace[12]}px;
    }
    .parent-treee-item .MuiTreeItem-label {
      padding-left: ${theme.uptimeSpace[5]}px;
    }
  `}
`;

export const StyledFormControlLabel = styled(FormControlLabel)(
  ({ theme }: IThemeProps) => `
    .MuiIconButton-root {
      padding: ${theme.uptimeSpace[5]}px !important;
    }
    .MuiIconButton-label {
      > div {padding: ${theme.uptimeSpace[0]}px !important;}
    }
    .MuiTypography-body1{
      font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    }
  `
);

export const BpIcon = styled('span')(({ theme }: IThemeProps) => ({
  borderRadius: '50%',
  width: 20,
  height: 20,
  boxShadow:
    `inset 0 0 0 2px ${theme.uptimeColors.grayScales.darkerGray}, inset 0 -1px 0${theme.uptimeColors.grayScales.darkerGray}`,
  backgroundColor: `${theme.uptimeColors.mainTheme.background}`,
  '&:hover': {
    backgroundColor: `${theme.uptimeColors.grayScales.grayishBackground}`,
  }
}));

export const BpCheckedIcon = styled(BpIcon)(({ theme }: IThemeProps) => ({
  backgroundColor: 'unset',
  boxShadow:
    `inset 0 0 0 2px ${theme.uptimeColors.mainTheme.primary}, inset 0 -1px 0 ${theme.uptimeColors.mainTheme.primary}`,
  backgroundImage: `linear-gradient(180deg,${theme.uptimeColors.grayScales.grayish},${theme.uptimeColors.grayScales.white})`,
  '&:before': {
    display: 'block',
    width: 20,
    height: 20,
    backgroundImage: `radial-gradient(${theme.uptimeColors.mainTheme.primary},${theme.uptimeColors.mainTheme.primary} 28%,transparent 32%)`,
    content: '""',
  }
}));


export const SvgIconStyled = styled.div(() => ({
  'svg': {
    width: 18,
    height: 18,
    fontSize: "inherit",
  }
}));
